import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="tm-footer" role="contentinfo">
      <div className="tm-footer-container">
        {/* Bloco da Marca à Esquerda */}
        <div className="tm-footer-brand-compact">
          <h3 className="tm-footer-logo">Confirma AI</h3>
          <p className="tm-footer-description">
            Plataforma inteligente para gestão de treinamentos e confirmação de presença.
          </p>
        </div>

        {/* Bloco de Copyright Centralizado */}
        <div className="tm-footer-copyright-compact">
          <p className="tm-copyright">
            © {currentYear} Confirma AI - Todos os direitos reservados.
          </p>
          <p className="tm-footer-info">
            Desenvolvido com <span aria-label="amor" role="img">💚</span> para gestão e controle inteligente.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;